import {GET_DEVICE_PAIRING_LIST, GET_NEW_PAIRING_CODE, GET_LICENSES} from '../constants/actionTypes';
import {API_ROOT, DEVICES_REPORT} from '../constants/config';
import {getAuthTokenHeader} from './remote';

export const get_device_pairing_list = () => dispatch => {
    const url = `${DEVICES_REPORT}/pairing-codes`;
    const options = {
    method: "GET",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        "Authorization": getAuthTokenHeader()
    },
    };
    fetch(url, options)
    .then((response) => response.json())
    .then(data => {
        console.log("DEVICE DATA", data)
        dispatch({type: GET_DEVICE_PAIRING_LIST, payload: data});
  });
}

export const delete_pairing_code = (id) => dispatch => {
    const url = `${DEVICES_REPORT}/delete-pairing/${id}`;
    const options = {
    method: "DELETE",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        "Authorization": getAuthTokenHeader()
    },
    };
    fetch(url, options)
    .then(() => dispatch(get_device_pairing_list()))

}

export const generate_pairing_code = (id) => dispatch => {
    const url = `${DEVICES_REPORT}/pairing-codes`;
    const options = {
    method: "POST",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        "Authorization": getAuthTokenHeader()
    },
    };
    fetch(url, options)
    .then(() => dispatch(get_device_pairing_list()))

}

export const get_license_list = () => dispatch => {
    const url = `${DEVICES_REPORT}/client-licenses`;
    const options = {
    method: "GET",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        "Authorization": getAuthTokenHeader()
    },
    };
    fetch(url, options)
    .then((response) => response.json())
    .then(data => {
        dispatch({type: GET_LICENSES, payload: data});
  });
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/deviceActions.js